<template>
  <div class="zhiliao">
       <!--顶部信息-->
       <div class="common-space-around" style="padding-bottom:100px">
          <div class="common-items-center">
              <div class="markY active">1</div>
              <div class="text">提交资质</div>
              <div class="line"></div>
              <div class="markY">2</div>
              <div class="text">等待审核</div>
              <div class="line"></div>
              <div class="markY">3</div>
              <div class="text">审核通过</div> 
              <div class="line"></div>
              <div class="markY">4</div>
              <div class="text">平台提供账号</div> 
              <div class="line"></div>
              <div class="markY">5</div>
              <div class="text">预付年费</div> 
          </div>
       </div>
       
  </div>
</template>

<script>
export default {
  data(){
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
    .zhiliao{
       padding:100px 0 0px 0;
       .markY{
          width: 32px;
          height: 32px;
          background: #F1F3F4;
          font-size: 18px;
          font-family: Montserrat, Montserrat;
          font-weight: 700;
          color: #333333;
          text-align:center;
          line-height: 32px;
          border-radius:50%;
       }
       .active{
          background: #367CFF;
          color: #FFFFFF;
       }
       .text{
          font-size: 16px;
          font-family: AlibabaPuHuiTi_2_65_Medium;
          color: #333333;
          margin-left:10px;
       }
       .line{
         width: 80px;
         height: 1px;
         background: #367CFF;
         margin: 0 20px;
       }
    }
</style>